<template>
  <div class="container _container">
    <div class="containerbody">
      <div class="content">
        <el-card class="card">
          <div class="main">
            <div class="contact_way">
              <el-row>
                <el-col v-for="(item,index) in imageList" :key="index" :span="6">
                  <el-popover
                    placement="bottom"
                    :title="item.title"
                    width="300"
                    trigger="click"
                    :content="item.content">
                    <el-image slot="reference" size="large " :src="item.url" v-if="item.isClick"
                              style="width: 100px;height: 100px;cursor: pointer" class="img"
                              @click="leaveMessageRouter"></el-image>
                    <el-image slot="reference" size="large " :src="item.url" v-if="!item.isClick"
                              style="width: 100px;height: 100px;cursor: pointer" class="img"></el-image>
                  </el-popover>
                  <div class="img-text" style="width: 100%;margin-top: 0.5em;">{{ item.title }}</div>
                </el-col>
              </el-row>
            </div>
            <br>
            <el-row class="contact_text">
              <el-col :span="1">
                <el-image size="large " :src="iconUrl" style="width: 95%;height: auto;"></el-image>
              </el-col>
              <el-col :span="22">
                <div class="contact_text_content">
                  {{
                    $t('home.address')
                  }}
                </div>
              </el-col>
            </el-row>
            <img src="../../assets/img/中心定位.png" width="100%">
            <div v-if="false" class="map" id="baiduMap"></div>
            <!-- <div class="leaveMessage"><el-button type="primary" style="width: 100%;" @click="leaveMessageRouter">{{ $t('home.leaveMessage')  }}</el-button></div> -->
            <!--            <iframe src="http://api.map.baidu.com/lbsapi/getpoint/index.html?ak=REOrlzOiWDstasqDmfCY1Lmjj27gzsiL&callback=initMap" style="width: 100%; height: 100%; border: none" scrolling="no"></iframe>-->
          </div>

        </el-card>

      </div>
    </div>
    <!-- <shareDialog ref="shareDialog"></shareDialog> -->
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      iconUrl: require('@/components/contact/imgs/icon.png'),
      imageList: [],
      imageListZh: [
        {
          url: require('@/components/contact/imgs/contact_img6.png'),
          title: "留言板",
          content: "点击进入留言板",
          isClick: true,
        },
        {
          url: require('@/components/contact/imgs/contact_img5.png'),
          title: "邮箱",
          content: "lmlecc@Im-lesc-center.org",
          isClick: false,
        },
        {
          url: require('@/components/contact/imgs/contact_img3.png'),
          title: "微信公众号",
          content: "澜湄执法合作中心LMLECC",
          isClick: false,
        },
        {
          url: require('@/components/contact/imgs/contact_img4.png'),
          title: "facebook",
          content: "",
          isClick: false,
        }

      ],
      imageListEn: [
        {
          url: require('@/components/contact/imgs/contact_img6.png'),
          title: "leave message",
          content: "Click to enter the message board",
          isClick: true,
        },
        {
          url: require('@/components/contact/imgs/contact_img5.png'),
          title: "E-mail",
          content: "lmlecc@Im-lesc-center.org",
          isClick: false,
        },
        {
          url: require('@/components/contact/imgs/contact_img3.png'),
          title: "WeChat official account",
          content: "Lancang-Mekong integrated Law Enforcement and Security Cooperation Center",
          isClick: false,
        },
        {
          url: require('@/components/contact/imgs/contact_img4.png'),
          title: "facebook",
          content: "",
          isClick: false,
        }

      ]
    }
  },
  mounted() {
    this.initMap();
    if (this.$i18n.locale == 'zh') {
      this.imageList = this.imageListZh
    } else {
      this.imageList = this.imageListEn
    }
  },
  methods: {
    initMap() {
      // // 创建一个script标签来引入百度地图API
      // const script = document.createElement('script');
      // script.type = 'text/javascript';
      // script.src = `https://api.map.baidu.com/api?v=2.0&ak=你的API密钥&callback=onBMapCallback`;
      // document.body.appendChild(script);
// 创建一个script标签来引入百度地图API
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://api.map.baidu.com/api?v=2.0&ak=你的API密钥&callback=onBMapCallback`;
      document.body.appendChild(script);
      // 定义回调函数
      window.onBMapCallback = () => {
        const map = new BMap.Map('baiduMap');
        const point = new BMap.Point(102.702187, 24.983998); // 地图中心点坐标
        map.enableScrollWheelZoom(true);
        map.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别
        const marker = new BMap.Marker(point); // 创建标记点
        map.addOverlay(marker);
        // 可以在这里添加更多地图配置和交互
      };
    },
    shareClick() {
      this.$refs.shareDialog.open('Repost to Facebook', {})

    },
    leaveMessageRouter() {
      this.$router.push({
        path: '/messageBoard',
      })
    },
  }
}
</script>

<style lang="less" scoped>
@media only screen and (min-width: 800px) {
  .container {
    width: 100%;
    overflow: hidden;

  }

  .containerbody {
    width: 100%;
    background-color: rgb(249, 249, 249);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;


  }

  .content {
    width: 60%;
    margin: 0 auto;

  }

  .main {
    width: 80%;
    /* height:500px; */
    margin: 50px auto;
    /* // display: flex;
    // align-items: center; */


  }

  .contact_way {
    width: 100%;
    height: 100px;

  }

  .contact_text {
    height: 50px;
    width: 100%;
    margin: 50px 0;
  }

  .contact_text_content {
    width: 100%;
    height: 100%;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: SourceHanSansCN-Regular;
    font-weight: normal;
    text-align: justify;
    line-height: 24px;
  }

  .leaveMessage {
    width: 100%;
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
  }

  .img {

  }

  .img:hover {
    animation: pulse; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s;
  }

  .map {
    //background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/df8337fef9e94889b745f2d8215f468c_mergeImage.png);
    width: 100%;
    height: 60vh;
    margin: 0px 0 28px 0px;
  }

  .card {
    margin-bottom: 12px;

  }
}

@media only screen and (max-width: 800px) {
  .map {
    width: 100%;
    height: 400px;
    margin: auto;
  }

  .contact_text {
    text-align: left;
    margin-top: 20px;
  }

  .img {
    width: 80% !important;
    height: 80% !important;
  }

  .img-text {
    font-size: 15px;
  }

}

</style>




// WEBPACK FOOTER //
// src/components/contact/index.vue